import { Component, OnInit, OnDestroy } from '@angular/core';
import { Message } from 'primeng/primeng';
import { NotificationsService } from '../services/notifications/notifications.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  growl: Message[] = [];
  message: Message[] = [];
  growlSubscription: Subscription;
  messageSubscription: Subscription;

  constructor(private notificationsService: NotificationsService) { }

  ngOnInit() {
    this.subscribeToGrowlNotifications();
    this.subscribeToMessageNotifications();
  }

  subscribeToGrowlNotifications() {
    this.growlSubscription = this.notificationsService.growlNotificationChange
      .subscribe(notification => {
        this.growl.push(notification);

        setTimeout(() => {
          this.growl.splice(this.growl.indexOf(notification), 1);
        }, 3000);
      });
  }

  subscribeToMessageNotifications() {
    this.messageSubscription = this.notificationsService.messageNotificationChange
      .subscribe(( notification: Message[])  => {
        this.message.length = 0;
        notification.forEach(element => {
          this.message.push(element);
        });
      });
  }

  ngOnDestroy() {
    this.growlSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/notifications/notifications.component.ts